export function getView(value) {
  switch (value) {
    case 'my-boards': {
      return 'MyBoardsIcon'
    }
    case 'other-boards': {
      return 'OtherBoardsIcon'
    }
    case 'private': {
      return 'PrivateBoardIcon'
    }
    default:
  }
}
